<template>
  <li class="review-item">
    <div class="review-header d-flex justify-content-between align-items-start">
      <div class="review-header-info">
        <div class="field"><span class="label">Project manager name:</span> {{ review.createdBy }}</div>
        <div class="field"><span class="label">Project number:</span> {{ review.projectNumber }}</div>
        <div class="field"><span class="label">Project name:</span> {{ review.projectName }}</div>
        <div class="field"><span class="label">Date:</span> {{ formattedCreatedDate }}</div>
      </div>
    <div class="review-header-actions">
      <mdb-icon
        v-if="canMoveUp"
        icon="arrow-up"
        class="action-icon"
        @click.native="$emit('move-up', review)"
        title="Move up"
      />
      <mdb-icon
        v-if="canMoveDown"
        icon="arrow-down"
        class="action-icon"
        @click.native="$emit('move-down', review)"
        title="Move down"
      />
      <mdb-icon
        v-if="canEdit"
        icon="pencil-alt"
        class="action-icon"
        @click.native="$emit('edit', review)"
        title="Edit review"
      />
      <mdb-icon
        v-if="canApprove"
        icon="check"
        class="action-icon"
        @click.native="$emit('approve', review)"
        title="Approve review"
      />
      <mdb-icon
        v-if="canReject"
        icon="times"
        class="action-icon"
        @click.native="$emit('reject', review)"
        title="Reject review"
      />
      <mdb-icon
        v-if="canDelete"
        icon="trash"
        class="action-icon"
        @click.native="$emit('delete', review)"
        title="Delete review"
      />
    </div>
    </div>
    <div class="review-subject">
      <strong>Review subject/title:</strong> {{ review.title || ('Review #' + review.id) }}
    </div>
    <div class="review-body">
      {{ review.message }}
    </div>
  </li>
</template>

<script>
export default {
  name: 'ReviewListItem',
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    // format creation date
    formattedCreatedDate() {
      const d = this.review.createdAt;
      if (!d) return '';
      return new Date(d).toLocaleString();
    },
    // permissions per state & user role
    canMoveUp() {
      return this.user.role === 3 && this.review.state === 1;
    },
    canMoveDown() {
      return this.user.role === 3 && this.review.state === 1;
    },
    canEdit() {
      let editableStates = [];
      if (this.user.role === 2 && this.review.createdBy === this.user.email) editableStates = [0,1,2];
      if (this.user.role === 3) editableStates = [0,1,2];
      return editableStates.includes(this.review.state);
    },
    canApprove() {
      return this.user.role === 3 && this.review.state != 1;
    },
    canReject() {
      return this.user.role === 3 && this.review.state === 0;
    },
    canDelete() {
      let deletableStates = [];
      if (this.user.role === 2 && this.review.createdBy === this.user.email) deletableStates = [0,1,2];
      if (this.user.role === 3) deletableStates = [1,2];
      return (this.user.role === 2 || this.user.role === 3) && deletableStates.includes(this.review.state);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/setup/_variables.scss";
.review-item {
  list-style: none;
  border: 1px solid #e0e0e0;
  border-radius: 0.4rem;
  margin-bottom: 1rem;
  overflow: visible;
}
.review-header {
  background-color: $isi-blue;
  color: #fff;
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.review-header-info .field {
  margin-bottom: 0.25rem;
  font-size: 0.85rem;
}
.review-header-info .label {
  font-weight: 600;
  margin-right: 0.25rem;
}
.review-header-actions .action-icon {
  color: #fff;
  margin-left: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
}
.review-subject {
  background-color: $isi-blue;
  color: #fff;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
}
.review-subject strong {
  color: #fff;
}
.review-body {
  background-color: #e2e8f7;
  padding: 1rem;
  font-size: 0.9rem;
  color: #333;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>